/**
 * AG Grid Module Registration
 * 
 * This file registers all AG Grid modules used in the application.
 * It must be imported before any AG Grid components are used.
 */

import { ModuleRegistry } from 'ag-grid-community';
import {
  ClientSideRowModelModule,
  GridStateModule,
  ValidationModule,
  TextFilterModule,
  NumberFilterModule,
  DateFilterModule,
  EventApiModule,
  ColumnApiModule,
  ExternalFilterModule,
  SelectEditorModule,
  TextEditorModule,
  DateEditorModule,
  RenderApiModule,
  RowApiModule,
  LargeTextEditorModule,
  CellStyleModule,
  CheckboxEditorModule,
  RowDragModule,
  RowSelectionModule,
  ClientSideRowModelApiModule,
  NumberEditorModule,
  PaginationModule,
  RowAutoHeightModule,
} from 'ag-grid-community';

// Register all modules
ModuleRegistry.registerModules([
  ClientSideRowModelModule,
  GridStateModule,
  ValidationModule,
  TextFilterModule,
  NumberFilterModule,
  DateFilterModule,
  EventApiModule,
  ColumnApiModule,
  ExternalFilterModule,
  SelectEditorModule,
  TextEditorModule,
  DateEditorModule,
  RenderApiModule,
  RowApiModule,
  LargeTextEditorModule,
  CellStyleModule,
  CheckboxEditorModule,
  RowDragModule,
  RowSelectionModule,
  ClientSideRowModelApiModule,
  NumberEditorModule,
  PaginationModule,
  RowAutoHeightModule,
]);
